module.exports = __webpack_public_path__ + "img/Frame2.e50f7635.svg";